// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__e9IWt","containerItemsCenter":"Skeleton_containerItemsCenter__1IU_q"};